import { render } from "./ProductAccordion.vue?vue&type=template&id=97f532b0&scoped=true"
import script from "./ProductAccordion.vue?vue&type=script&lang=js"
export * from "./ProductAccordion.vue?vue&type=script&lang=js"

import "./ProductAccordion.vue?vue&type=style&index=0&id=97f532b0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97f532b0"]])

export default __exports__